const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, ToggleControl, TextControl } = wp.components;

import ImageControl from '../wp-controlers/mediaUpload';
import CommonPanel from '../wp-controlers/common-panel';
import SelectBackground from '../wp-controlers/select-background';

const Inspector = ({ attributes, setAttributes }) => {
  const {
    variant,
    removeImage,
    sizeImage,
    hAlign,
    textAfter,
    variantColored,
    originalSize,
    marginImage,
    hasNumber,
  } = attributes;

  const haveImage =
    variant === 'default' ||
    variant === 'defaultHorizontal' ||
    variant === 'defaultHorizontalBig' ||
    variant === 'bordered' ||
    variant === 'borderedHorizontal' ||
    variant === 'plans' ||
    variant === 'withBackground' ||
    variant === 'withTopicsExtended' ||
    variant === 'cover' ||
    variant === 'coverWithText' ||
    variant === 'bgColored' ||
    variant === 'rokuCard' ||
    variant === 'stepPartner';

  return (
    <InspectorControls>
      <PanelBody title="Dados do Card" initialOpen={true}>
        <SelectControl
          label="Selecione o estilo do card"
          title="Selecione o estilo do card"
          value={variant}
          options={[
            { label: 'Padrão', value: 'default' },
            { label: 'Padrão na horizontal', value: 'defaultHorizontal' },
            {
              label: 'Padrão na horizontal grande',
              value: 'defaultHorizontalBig',
            },
            { label: 'Capa', value: 'cover' },
            { label: 'Capa 2', value: 'coverWithText' },
            { label: 'Com borda', value: 'bordered' },
            { label: 'Com borda - horizontal  ', value: 'borderedHorizontal' },
            { label: 'Com tópicos', value: 'withTopics' },
            { label: 'Com tópicos extendido', value: 'withTopicsExtended' },
            { label: 'Localização', value: 'locate' },
            { label: 'Resultado de busca', value: 'search' },
            { label: 'Circular', value: 'circular' },
            { label: 'Com título colorido', value: 'titleColored' },
            { label: 'Com background', value: 'bgColored' },
            { label: 'Passos para ser um parceiro', value: 'stepPartner' },
            { label: 'Roku Card', value: 'rokuCard' },
          ]}
          onChange={(position) => setAttributes({ variant: position })}
        />

        {haveImage && (
          <>
            <ImageControl
              label="Imagem do Card"
              image="image"
              attributes={attributes}
              setAttributes={setAttributes}
            />
            <SelectControl
              label="Largura da imagem"
              title="Largura da imagem"
              value={sizeImage}
              options={[
                { label: 'Normal', value: 'normal' },
                { label: 'Grande', value: 'big' },
              ]}
              onChange={(position) => setAttributes({ sizeImage: position })}
            />
            <SelectControl
              label="Margem abaixo da imagem: (mobile - desktop)"
              title="Margem abaixo da imagem: (mobile - desktop)"
              value={marginImage}
              options={[
                { label: 'Nenhuma', value: 'margin-none' },
                {
                  label: 'Extra Smal (4px - 16px)',
                  value: 'margin-extra-small',
                },
                { label: 'Small (12px - 24px)', value: 'margin-small' },
                { label: 'Base (16px - 32px)', value: 'margin-base' },
                { label: 'Medium (24px - 42px)', value: 'margin-medium' },
                { label: 'Large (32px - 64px)', value: 'margin-large' },
                { label: 'Huge (42px - 96px)', value: 'margin-huge' },
                {
                  label: 'Section Small (32px - 32px)',
                  value: 'margin-section-small',
                },
                {
                  label: 'Section Base (64px - 64px)',
                  value: 'margin-section-base',
                },
                {
                  label: 'Section Large (96px - 96px)',
                  value: 'margin-section-large',
                },
              ]}
              onChange={(position) => setAttributes({ marginImage: position })}
            />
          </>
        )}

        {variant == 'bordered' && (
          <ToggleControl
            label="Usar tamanho orginal da imagem ?"
            checked={originalSize}
            onChange={() => setAttributes({ originalSize: !originalSize })}
          />
        )}

        {(variant !== 'withTopicsExtended' || variant !== 'cover') && (
          <ToggleControl
            label="Remover imagem do card?"
            checked={removeImage}
            onChange={() => setAttributes({ removeImage: !removeImage })}
          />
        )}

        {variant != 'coverWithText' && (
          <SelectControl
            label="Alinhamento horizontal"
            title="Alinhamento horizontal"
            value={hAlign}
            options={[
              { label: 'Esquerda', value: 'hAlign-left' },
              { label: 'Centro', value: 'hAlign-center' },
              { label: 'Direita', value: 'hAlign-right' },
            ]}
            onChange={(position) => setAttributes({ hAlign: position })}
          />
        )}

        {variant === 'coverWithText' && (
          <TextControl
            label="Âncora: "
            value={attributes.anchor}
            onChange={(value) => setAttributes({ anchor: value })}
          />
        )}

        {variant === 'defaultHorizontal' && (
          <ToggleControl
            label="Colocar texto em baixo da imagem em mobile ?"
            checked={textAfter}
            onChange={() => setAttributes({ textAfter: !textAfter })}
          />
        )}

        {variant === 'titleColored' && (
          <SelectControl
            label="Selecione a cor do card "
            title="Selecione a cor do card "
            value={variantColored}
            options={[
              { label: 'Azul', value: 'cardBlue' },
              { label: 'Azul marinho', value: 'cardBlueNavy' },
            ]}
            onChange={(position) => setAttributes({ variantColored: position })}
          />
        )}

        {variant === 'bgColored' && (
          <SelectBackground
            attributes={attributes}
            setAttributes={setAttributes}
          />
        )}

        {variant == 'circular' && (
          <ToggleControl
            label="Deseja numerar os itens?"
            checked={hasNumber}
            onChange={() => setAttributes({ hasNumber: !hasNumber })}
          />
        )}
      </PanelBody>
      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
